import { observer } from 'mobx-react-lite'
import { Navigate } from 'react-router-dom'
import { useHomepage } from 'app/hooks/useHomepage'

/**
 * Resolves `/` to the user's homepage: their pinned page, else the Action Center when
 * they have it, else contacts.
 */
export const HomeRedirect = observer(function HomeRedirect() {
  const { href, loaded } = useHomepage()

  // Nothing, not a redirect, until settings and toggles are both in. Answering early
  // would bounce every reload to the fallback before the user's own pin had arrived,
  // the same reason FeatureRoute waits.
  if (!loaded) return null
  return <Navigate to={href} replace />
})
